// extracted by mini-css-extract-plugin
module.exports = {"label":"Breadcrumb_label__Jb9tg","labelActive":"Breadcrumb_labelActive__g0xwn"};